module.exports = __webpack_public_path__ + "img/流体力学5_6.5db772cc.jpg";